var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("图表介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("Pie， 饼图。")]),
      _vm._v(" "),
      _c("h3", [_vm._v("attrs")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性名")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("clientRect")]),
            _vm._v(" "),
            _c("td", [_vm._v("Object")]),
            _vm._v(" "),
            _c("td", [_vm._v("{top,right,bottom,left,width,height}")]),
            _vm._v(" "),
            _c("td", [_vm._v("设置了 width,heigh,优先与 bottom,right")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("startAngle")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("Math.PI * -0.5")])]),
            _vm._v(" "),
            _c("td", [_vm._v("起始角度")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("endAngle")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("Math.PI * 1.5")])]),
            _vm._v(" "),
            _c("td", [_vm._v("结束角度")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("radius")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("0.8")])]),
            _vm._v(" "),
            _c("td", [_vm._v("外半径比例")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("innerRadius")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("0")])]),
            _vm._v(" "),
            _c("td", [_vm._v("内半径比例")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("animation")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean,Object")]),
            _vm._v(" "),
            _c("td", [_vm._v("{easing:'',duration}")]),
            _vm._v(" "),
            _c("td", [_vm._v("动画配置")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("style")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" pie = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Pie()\npie.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'text'")
            ]),
            _vm._v(", { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("color")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'#fff'")
            ]),
            _vm._v(" }\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("组件中可以自定义 css 属性的元素如下表：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基础类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("sector")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("扇形样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("text")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("扇形上文字样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("guideline")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("指导线样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("guideText")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("指导文字样式")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }